import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../Navbar';
import Footer from '../Footer';
import FloatingScrollToTop from '../FloatingScrollToTop';
import MobileActionBar from '../ui/MobileActionBar';
import { useV2Motion } from '../v2/useV2Motion';
import { useRevealStaticHero } from '../../hooks/useRevealStaticHero';

export default function PageShell({ children }) {
  const scopeRef = useRef(null);
  const { pathname } = useLocation();
  useV2Motion(scopeRef, pathname);
  // Every page must drop the pre-hydration hero overlay from index.html, or it covers the content.
  useRevealStaticHero();

  return (
    <div className="fw-page" ref={scopeRef}>
      {/* Background glows live in a clipped layer so they never make a short page taller than its content. */}
      <div className="fw-orbs" aria-hidden="true">
        <div className="orb" style={{ width: 520, height: 520, left: -160, top: -120, background: '#9DB6FF', opacity: 0.75 }} />
        <div className="orb" style={{ width: 460, height: 460, right: -120, top: 80, background: '#FFD39A', opacity: 0.8 }} />
        <div className="orb" style={{ width: 420, height: 420, left: '30%', top: 520, background: '#C9B8FF', opacity: 0.6 }} />
        <div className="orb" style={{ width: 520, height: 520, right: -200, top: 1500, background: '#A8F0CF', opacity: 0.6 }} />
        <div className="orb" style={{ width: 560, height: 560, left: -220, top: 2400, background: '#9DB6FF', opacity: 0.6 }} />
      </div>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <div className="m-dock-spacer md:hidden" aria-hidden />
      <FloatingScrollToTop />
      <MobileActionBar />
    </div>
  );
}
